jQuery(document).ready(function(){
setTimeout(function () {
  if(jQuery('.SizeSwatchList').find('li.simple').length > 0){
    var simple_product_html = jQuery('.SizeSwatchList').find('li.simple').html();
    jQuery('div[option-name="Size"] ul li:first-child').before('<li class="swatch-view-item link-product simple">'+simple_product_html+'</li>');
  }
 if(jQuery('.SizeSwatchList').find('li.curve').length > 0){
    var curve_product_html = jQuery('.SizeSwatchList').find('li.curve').html();
    jQuery('div[option-name="Size"] ul li:last-child').after('<li class="swatch-view-item link-product curve">'+curve_product_html+'</li>');
  }
}, 1000);
   jQuery(document).on('click','.swatch-view-sizes .swatch-size',function(){
      jQuery('.product-card').find('.error').remove();
      jQuery('.swatch-size').removeClass('active');
      jQuery(this).addClass('active');
      var text = jQuery(this).text();
      var product_handle = jQuery(this).parents('.product-card').attr('swatch-generated');
      var variant_id = '';
      var product_object = '';
      product_object = jQuery(this).parents('.product-card').find('.product_obj_'+product_handle).text();
      product_object = JSON.parse(product_object);
      var variants = product_object.variants;
      for (let index = 0; index < variants.length; index++) {
          if(text == variants[index].option2){
            variant_id = variants[index].id;
            if( variants[index].available == false){
              jQuery(this).parents('.product-card').find('.error').remove();
              jQuery(this).parents('.product-card').find('.swatch-view-sizes').after('<p class="error">Sold Out!</p>');
            } 
          }
        }
      var currency = jQuery(this).attr('currency');
      var color = jQuery('.swatch-custom-image.swatch-selected').attr('data-value');
      let formData = {
      'items': [{
        'id': variant_id,
        'quantity': 1
      }]
    };
    jQuery.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: formData,
      success: function (data){
             jQuery.ajax({
               type: 'GET',
               dataType: 'jsonp',
               url: '/cart.json',
               success: function(cart){
                 //console.log(cart);
                window.monster_setCartItems(cart.items);
                window.mu_productionAddToCartCallBack(cart.items);
                window.openCart();
                 // var item_count = cart['item_count'];
                 // var total_price = cart['total_price']/100;
                 // if ( item_count > 0 ) {
                 //    var cart_footer_html = '';
                 //    cart_footer_html += '<div class="Drawer__Footer" data-drawer-animated-bottom="">';
                 //    cart_footer_html += '<button type="button" class="Cart__NoteButton" data-action="toggle-cart-note">Add Order Note</button>';
                 //    cart_footer_html += '<p class="Cart__Taxes Text--subdued">Shipping &amp; taxes calculated at checkout</p>';
                 //    cart_footer_html += '<button type="submit" name="checkout" class="Cart__Checkout Button Button--primary Button--full">';
                 //    cart_footer_html += '<span>Checkout</span>';
                 //    cart_footer_html += '<span class="Button__SeparatorDot"></span>';
                 //    cart_footer_html += '<span>'+ currency + total_price.toFixed(2) +' AUD</span>';
                 //    cart_footer_html += '</button><div class="Cart__OffscreenNoteContainer" aria-hidden="true"><span class="Cart__NoteButton">Add Order Note</span>';
                 //    cart_footer_html += '<div class="Form__Item">';
                 //    cart_footer_html += '<textarea class="Cart__Note Form__Textarea" name="note" id="cart-note" rows="3" placeholder="How can we help you?" data-scrollable="">';
                 //    cart_footer_html += '</textarea></div>';
                 //    cart_footer_html += '<button type="button" class="Button Button--primary Button--full" data-action="toggle-cart-note">Save</button>';
                 //    cart_footer_html += '</div></div>';
                 //   jQuery('.Drawer__Main .Cart__Empty').remove();
                 //   jQuery('.Drawer__Main').empty();
                 //   jQuery('.Cart.Drawer__Content .Drawer__Footer').remove();
                 //   jQuery('.Drawer__Main').append('<div class="Drawer__Container"></div>');
                 //   jQuery('.Drawer__Main .Drawer__Container').append('<input type="hidden" name="attributes[collection_mobile_items_per_row]" value=""><input type="hidden" name="attributes[collection_desktop_items_per_row]" value="">');
                 //   jQuery('.Drawer__Main .Drawer__Container').append('<div class="Cart__ItemList">');
                 //   jQuery('.Drawer__Main').after(cart_footer_html);
                 //   jQuery('.Drawer__Container .Cart__ItemList').empty();
                 //   jQuery.each( cart.items, function( key, value ) {
                 //     var value = JSON.stringify(value);
                 //     var parse_value = JSON.parse(value);
                 //     var quantity = parse_value.quantity;
                 //     var decrease_quantity = parse_value.quantity - 1;
                 //     var increase_quantity = parse_value.quantity + 1;
                 //     var product_title = parse_value.product_title;
                 //     var variant_title = parse_value.variant_title
                 //     var line_price = parse_value.price;
                 //     var url = parse_value.url;
                 //     var image_url = parse_value.image;
                 //     var key = parse_value.key;
                     
                 //     line_price = parseFloat(line_price)/100;
                 //     //line_price = line_price.toFixed(2).replace(".",",");
                 //      var cart_html = '';
                 //      cart_html += '<div class="CartItemWrapper">';
                 //      cart_html += '<div class="CartItem">';
                 //      cart_html += '<div class="CartItem__ImageWrapper AspectRatio">';
                 //      cart_html += '<div class="AspectRatio" style="--aspect-ratio: 0.6668">';
                 //      cart_html += '<img class="CartItem__Image" src="'+image_url+'" alt="dk active'+product_title+'">';
                 //      cart_html += '</div></div>';
                 //      cart_html += '<div class="CartItem__Info"><h2 class="CartItem__Title Heading">';
                 //      cart_html += '<a href="'+url+'">'+product_title+'</a></h2>';
                 //      cart_html += '<div class="CartItem__Meta Heading Text--subdued">';
                 //      cart_html += '<p class="CartItem__Variant">'+variant_title+'</p>';
                 //      cart_html += '<ul class="CartItem__PropertyList"></ul>';
                 //      cart_html += '<div class="CartItem__PriceList">';
                 //      cart_html += '<span class="CartItem__Price Price">'+ currency + line_price +'</span></div></div>';
                 //      cart_html += '<div class="CartItem__Actions Heading Text--subdued" style="text-align: center">';
                 //      cart_html += '<div class="CartItem__QuantitySelector">';
                 //      cart_html += '<div class="QuantitySelector">';
                 //      cart_html += '<a class="QuantitySelector__Button Link Link--primary" title="Set quantity to '+decrease_quantity+'" href="/cart/change?quantity='+decrease_quantity+'&amp;line='+quantity+'" data-quantity="'+decrease_quantity+'" data-line="'+quantity+'" data-action="update-item-quantity">';
                 //      cart_html += '<svg class="Icon Icon--minus " role="presentation" viewBox="0 0 16 2">';
                 //      cart_html += '<path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>';
                 //      cart_html += '</svg></a>';
                 //      cart_html += '<input type="text" name="updates[]" id="updates_'+key+'" class="QuantitySelector__CurrentQuantity" pattern="[0-9]*" data-line="'+quantity+'" value="'+quantity+'">';
                 //      cart_html += '<a class="QuantitySelector__Button Link Link--primary" title="Set quantity to '+increase_quantity+'" href="/cart/change?quantity='+increase_quantity+'&amp;line='+quantity+'" data-quantity="'+increase_quantity+'" data-line="'+quantity+'" data-action="update-item-quantity">';
                 //      cart_html += '<svg class="Icon Icon--plus " role="presentation" viewBox="0 0 16 16">';
                 //      cart_html += '<g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">';
                 //      cart_html += '<path d="M8,1 L8,15"></path><path d="M1,8 L15,8"></path></g></svg></a>';
                 //      cart_html += '</div></div>';
                 //      cart_html += '<a href="/cart/change?quantity=0&amp;line='+quantity+'" class="CartItem__Remove Link Link--underline Link--underlineShort" data-quantity="0" data-line="'+quantity+'" data-action="remove-item">Remove</a>';
                 //      cart_html += '</div></div></div>';
                 //      cart_html += '</div>';

                 //     jQuery('.Drawer__Container .Cart__ItemList').append(cart_html);
                 //   });
      
                 //   jQuery('a[data-drawer-id="sidebar-cart"]')[0].click();
      
                 // } 
               }
        });
      }
    });

   });
});